/**
 * @generated SignedSource<<e9940a4ddc5e16a678e7c798b3c5de1c>>
 * @relayHash 81e0ec3084120c0be1f11ccafd133340
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d12d7ebbccf4878f0dfbd2b2e4f86b05fa695f03a27498a938b402a9f5529b9a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useDetailsSummaryADFQueryQuery$variables = {
  contentId: string;
  contentRepresentation?: string | null | undefined;
  countComments?: boolean | null | undefined;
  countLikes?: boolean | null | undefined;
  countUnresolvedComments?: boolean | null | undefined;
  cql?: string | null | undefined;
  detailsId?: string | null | undefined;
  headings?: string | null | undefined;
  macroId?: string | null | undefined;
  pageIndex?: number | null | undefined;
  pageSize?: number | null | undefined;
  reverseSort?: boolean | null | undefined;
  showCreator?: boolean | null | undefined;
  showLastModified?: boolean | null | undefined;
  showPageLabels?: boolean | null | undefined;
  sortBy?: string | null | undefined;
  spaceKey: string;
};
export type useDetailsSummaryADFQueryQuery$data = {
  readonly detailsLines: {
    readonly currentPage: number;
    readonly detailLines: ReadonlyArray<{
      readonly commentsCount: number;
      readonly creator: {
        readonly accountId: string;
        readonly name: string;
      } | null | undefined;
      readonly details: ReadonlyArray<string | null | undefined>;
      readonly id: AGG$Long;
      readonly labels: ReadonlyArray<{
        readonly displayTitle: string;
        readonly name: string;
        readonly urlPath: string;
      } | null | undefined>;
      readonly lastModified: {
        readonly friendlyModificationDate: string;
        readonly sortableDate: string;
      } | null | undefined;
      readonly macroId: string | null | undefined;
      readonly reactionsCount: number;
      readonly relativeLink: string;
      readonly rowId: number;
      readonly title: string;
      readonly unresolvedCommentsCount: number;
    } | null | undefined>;
    readonly macroId: string | null | undefined;
    readonly renderedHeadings: ReadonlyArray<string | null | undefined>;
    readonly totalPages: number;
  } | null | undefined;
};
export type useDetailsSummaryADFQueryQuery = {
  response: useDetailsSummaryADFQueryQuery$data;
  variables: useDetailsSummaryADFQueryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": "atlas_doc_format",
  "kind": "LocalArgument",
  "name": "contentRepresentation"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "countComments"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "countLikes"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "countUnresolvedComments"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "detailsId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "headings"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "macroId"
},
v9 = {
  "defaultValue": 0,
  "kind": "LocalArgument",
  "name": "pageIndex"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reverseSort"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showCreator"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showLastModified"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showPageLabels"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortBy"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v17 = {
  "kind": "ScalarField",
  "name": "macroId"
},
v18 = {
  "kind": "ScalarField",
  "name": "name"
},
v19 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentRepresentation",
        "variableName": "contentRepresentation"
      },
      {
        "kind": "Variable",
        "name": "countComments",
        "variableName": "countComments"
      },
      {
        "kind": "Variable",
        "name": "countLikes",
        "variableName": "countLikes"
      },
      {
        "kind": "Variable",
        "name": "countUnresolvedComments",
        "variableName": "countUnresolvedComments"
      },
      {
        "kind": "Variable",
        "name": "cql",
        "variableName": "cql"
      },
      {
        "kind": "Variable",
        "name": "detailsId",
        "variableName": "detailsId"
      },
      {
        "kind": "Variable",
        "name": "headings",
        "variableName": "headings"
      },
      {
        "kind": "Variable",
        "name": "macroId",
        "variableName": "macroId"
      },
      {
        "kind": "Variable",
        "name": "pageIndex",
        "variableName": "pageIndex"
      },
      {
        "kind": "Variable",
        "name": "pageSize",
        "variableName": "pageSize"
      },
      {
        "kind": "Variable",
        "name": "reverseSort",
        "variableName": "reverseSort"
      },
      {
        "kind": "Variable",
        "name": "showCreator",
        "variableName": "showCreator"
      },
      {
        "kind": "Variable",
        "name": "showLastModified",
        "variableName": "showLastModified"
      },
      {
        "kind": "Variable",
        "name": "showPageLabels",
        "variableName": "showPageLabels"
      },
      {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
      },
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "DetailsSummaryLines",
    "kind": "LinkedField",
    "name": "detailsLines",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "currentPage"
      },
      {
        "kind": "ScalarField",
        "name": "totalPages"
      },
      {
        "kind": "ScalarField",
        "name": "renderedHeadings"
      },
      (v17/*: any*/),
      {
        "concreteType": "DetailLine",
        "kind": "LinkedField",
        "name": "detailLines",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "title"
          },
          {
            "kind": "ScalarField",
            "name": "relativeLink"
          },
          {
            "kind": "ScalarField",
            "name": "details"
          },
          {
            "kind": "ScalarField",
            "name": "reactionsCount"
          },
          {
            "kind": "ScalarField",
            "name": "commentsCount"
          },
          {
            "kind": "ScalarField",
            "name": "rowId"
          },
          (v17/*: any*/),
          {
            "kind": "ScalarField",
            "name": "unresolvedCommentsCount"
          },
          {
            "concreteType": "DetailLabels",
            "kind": "LinkedField",
            "name": "labels",
            "plural": true,
            "selections": [
              (v18/*: any*/),
              {
                "kind": "ScalarField",
                "name": "displayTitle"
              },
              {
                "kind": "ScalarField",
                "name": "urlPath"
              }
            ]
          },
          {
            "concreteType": "DetailCreator",
            "kind": "LinkedField",
            "name": "creator",
            "plural": false,
            "selections": [
              (v18/*: any*/),
              {
                "kind": "ScalarField",
                "name": "accountId"
              }
            ]
          },
          {
            "concreteType": "DetailLastModified",
            "kind": "LinkedField",
            "name": "lastModified",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "friendlyModificationDate"
              },
              {
                "kind": "ScalarField",
                "name": "sortableDate"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useDetailsSummaryADFQueryQuery",
    "selections": (v19/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v6/*: any*/),
      (v15/*: any*/),
      (v11/*: any*/),
      (v16/*: any*/),
      (v0/*: any*/),
      (v10/*: any*/),
      (v9/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v14/*: any*/),
      (v13/*: any*/),
      (v12/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "useDetailsSummaryADFQueryQuery",
    "selections": (v19/*: any*/)
  },
  "params": {
    "cacheID": "81e0ec3084120c0be1f11ccafd133340",
    "id": "d12d7ebbccf4878f0dfbd2b2e4f86b05fa695f03a27498a938b402a9f5529b9a",
    "metadata": {},
    "name": "useDetailsSummaryADFQueryQuery",
    "operationKind": "query",
    "text": "query useDetailsSummaryADFQueryQuery($cql:String,$detailsId:String,$sortBy:String,$reverseSort:Boolean,$spaceKey:String!,$contentId:ID!,$pageSize:Int,$pageIndex:Int=0,$countComments:Boolean,$countUnresolvedComments:Boolean,$countLikes:Boolean,$showPageLabels:Boolean,$showLastModified:Boolean,$showCreator:Boolean,$headings:String,$contentRepresentation:String=\"atlas_doc_format\",$macroId:String){detailsLines(cql:$cql,detailsId:$detailsId,sortBy:$sortBy,reverseSort:$reverseSort,spaceKey:$spaceKey,contentId:$contentId,pageSize:$pageSize,pageIndex:$pageIndex,countComments:$countComments,countUnresolvedComments:$countUnresolvedComments,countLikes:$countLikes,showPageLabels:$showPageLabels,showLastModified:$showLastModified,showCreator:$showCreator,headings:$headings,contentRepresentation:$contentRepresentation,macroId:$macroId){currentPage,totalPages,renderedHeadings,macroId,detailLines{id,title,relativeLink,details,reactionsCount,commentsCount,rowId,macroId,unresolvedCommentsCount,labels{name,displayTitle,urlPath},creator{name,accountId},lastModified{friendlyModificationDate,sortableDate}}}}"
  }
};
})();

(node as any).hash = "e2f904ef103ed055ad0661a39595ea5b";

export default node;
